import { render, staticRenderFns } from "./_keyword.vue?vue&type=template&id=c9530b4c&scoped=true&name=search&"
import script from "./_keyword.vue?vue&type=script&lang=js&"
export * from "./_keyword.vue?vue&type=script&lang=js&"
import style0 from "./_keyword.vue?vue&type=style&index=0&id=c9530b4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9530b4c",
  null
  
)

/* custom blocks */
import block0 from "./_keyword.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports